  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

document.addEventListener('DOMContentLoaded', () => {
  const nav = document.createElement('nav');
  if(document.querySelector('.glossary__content')){
      nav.classList.add('glossary__nav');
      const glossaryWrapper = document.querySelector('.glossary__content');
      const headers = glossaryWrapper.querySelectorAll('h3, h4');
      const letters = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      const existingSections = new Set();

      headers.forEach(header => {
        let letter = header.textContent.trim();
        if (letter.includes('<br>')) {
          letter = letter.replace('<br>', '');
        }
        if (letters.includes(letter)) {
          header.id = letter; 
          existingSections.add(letter);
        }
      });

      letters.forEach((letter,index) => {
        const sectionExists = existingSections.has(letter);
        const link = document.createElement('a');
        link.href = sectionExists ? `#${letter}` : '#';
        link.id = `nav-${letter}`;
        link.textContent = letter;
        // Default add active for A
        if(index == 1 && sectionExists){
            link.classList.add('active')
        }

        if (!sectionExists) {
          link.style.opacity = '0.5';
          link.style.pointerEvents = 'none';
          link.setAttribute('disabled', 'disabled');
        }

        nav.appendChild(link);
      });

      const glossary = document.querySelector('.glossary__lists');
      glossary.appendChild(nav);

      document.querySelectorAll('.glossary__nav a:not([disabled])').forEach(link => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const hash = link.getAttribute('href');
          document.querySelectorAll('.glossary__nav a').forEach(it => it.classList.remove('active'));
          link.classList.add('active');
          if (hash !== '#') {
            const target = document.querySelector(hash);
            if (target) {
              window.scrollTo({
                top: target.getBoundingClientRect().top + window.scrollY - 300, // Offset for nav bar
                behavior: 'smooth'
              });
            }
          }
        });
      });

      // IntersectionObserver for active section highlighting
      const observerOptions = {
        root: null,
        rootMargin: `-300px 0px -100% 0px`,
        threshold: 0
      };

      let  glossaryTimeout;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if(glossaryTimeout) clearTimeout(glossaryTimeout);
            glossaryTimeout = setTimeout(function(){
                const letter = entry.target.textContent.trim().replace('<br>', '');
                if (letters.includes(letter)) {
                document.querySelectorAll('.glossary__nav a').forEach(link => link.classList.remove('active'));
                const activeLink = document.querySelector(`.glossary__nav a[href="#${letter}"]`);
                if (activeLink) activeLink.classList.add('active');
                }
            },200)
          }
        });
      }, observerOptions);
      headers.forEach(header => observer.observe(header));
  }
});